import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import { useTheme } from '@mui/material/styles'
import AddAccounts from './AddAccounts'
import { DialogActions, DialogContent, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

import DirectionSnackbar from './Snackbar'
import { makePostRequest } from 'utils/api'
import { makeGetRequest } from 'utils/api'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'

export default function ResponsiveDialog({ updateTable, openFromUrl = false, onUrlOpenConsumed = null }) {
  let w_account = localStorage.getItem('w-account')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation('layout') // LAP-733 (GE022)

  const theme = useTheme()
  const [open, setOpen] = React.useState(false)

  const [openSnack, setOpenSnak] = useState({
    message: '',
    color: '',
    open: false,
  })
  const [state, setState] = useState({
    acType: null,
    bankData: null,
    // Titulaire: null,
    IBAN: null,
    csv1: null,
    csv2: null,
    newAccType: null,
  })
  useEffect(() => {
    if (w_account) {
      setOpen(true)
    }
  }, [])
  useEffect(() => {
    if (openFromUrl) {
      setOpen(true)
      if (onUrlOpenConsumed) onUrlOpenConsumed()
    }
  }, [openFromUrl, onUrlOpenConsumed])
  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value })
  }
  const handleAutocomplete = (name, val) => {
    const extractLabel = val
    setState({ ...state, [name]: extractLabel && extractLabel.value })
  }

  const handleFileUpload = (e) => {
    setState({ ...state, [e.target.name]: e.target.files[0] })
  }
  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setOpenSnak({ ...openSnack, open: false })
    setState({
      acType: null,
      bankData: null,
      // Titulaire: null,
      IBAN: null,
      csv1: null,
      csv2: null,
      newAccType: null,
    })
  }
  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }
  const addAccDone = async () => {
    if (w_account) {
      await makePostRequest(
        '/api/app/user-wizard/',
        { step: w_account, completed: true, skip: true },
        {},
        true,
      )
      await sleep(2000)
      dispatch(setUserWizardDone({ step: w_account, completed: true, skip: false }))
      localStorage.removeItem('w-account')
      localStorage.setItem('w-account-added', true)
      localStorage.setItem('t_message', '1 compte ajouté.')
      navigate('/')
    }
  }
  const addAccount = async (e) => {
    if (state.acType === 3) {
      const formData = new FormData()
      formData.append('Nom', state.bankData)
      formData.append('TypeCompte', state.newAccType)
      formData.append('IBAN', state.IBAN)
      formData.append('nom', state.nom)
      formData.append('rib', state.rib)
      formData.append('client', state.client)
      formData.append('date', state.date)
      formData.append('devise', state.devise)
      formData.append('compte', state.compte)

      // formData.append('Titulaire', state.Titulaire)

      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      makePostRequest(
        '/api/Finance/POST/New-Accounts/',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
        true,
      ).then((res) => {
        if (res.data === 'IBAN is INVALID') {
          setOpenSnak({
            open: true,
            color: 'error',
            message: 'IBAN Already Exists',
          })
          setTimeout(() => {
            setOpenSnak({
              open: false,
              color: 'success',
              message: 'Account add Successfully',
            })
          }, 2000)
        } else {
          updateTable()
          handleClose()

          setOpenSnak({
            open: true,
            color: 'success',
            message: 'Account add Successfully',
          })
          setTimeout(() => {
            setOpenSnak({
              open: false,
              color: 'success',
              message: 'Account add Successfully',
            })
          }, 2000)
          addAccDone()
        }
      })
      return
    }
    if (state.acType === 1) {
      const res = await makeGetRequest('/api/Finance/open-bank/', {}, true)
      if (res.status === 200) {
        console.log(res.data)
        window.location.replace(res.data)
      }
      handleClose()
      return
    }
    if (
      state.bankData === null ||
      state.newAccType === null ||
      state.csv1 === null ||
      state.IBAN === null ||
      state.csv2 === null
    ) {
      setOpenSnak({
        open: true,
        color: 'error',
        message: 'All fields are required',
      })
      setTimeout(() => {
        setOpenSnak({
          open: false,
          color: 'success',
          message: 'Account add Successfully',
        })
      }, 2000)
    } else {
      const formData = new FormData()
      formData.append('csv1', state.csv1)
      formData.append('csv2', state.csv2)
      formData.append('Nom', state.bankData)
      formData.append('TypeCompte', state.newAccType)
      formData.append('IBAN', state.IBAN)

      // formData.append('Titulaire', state.Titulaire)

      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      makePostRequest(
        '/api/Finance/POST/NewAccounts/',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
        true,
      ).then((res) => {
        if (res.data === 'IBAN is INVALID') {
          setOpenSnak({
            open: true,
            color: 'error',
            message: 'IBAN Already Exists',
          })
          setTimeout(() => {
            setOpenSnak({
              open: false,
              color: 'success',
              message: 'Account add Successfully',
            })
          }, 2000)
        } else {
          updateTable()
          handleClose()

          setOpenSnak({
            open: true,
            color: 'success',
            message: 'Account add Successfully',
          })
          setTimeout(() => {
            setOpenSnak({
              open: false,
              color: 'success',
              message: 'Account add Successfully',
            })
          }, 2000)
          addAccDone()
        }
      })
    }
  }
  return (
    <>
      {openSnack.open && <DirectionSnackbar message={openSnack.message} color={openSnack.color} />}

      <Button
        size="small"
        sx={{
          color: 'white',
          '&:hover': { color: 'black', backgroundColor: 'white' },
        }}
        onClick={handleClickOpen}
      >
        {t('finance.common.add')}
      </Button>
      <Dialog
        open={open}
        // onClose={handleClose}
        maxWidth="xs"
        // minWidth="xs"
        // width="444px"
        className="aaaa"
        sx={{ '.MuiPaper-root': { width: 444 } }}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Typography
            sx={{ backgroundColor: theme.palette.appBg }}
            align="center"
            variant="h5"
            p={1}
            borderRadius="5px"
            gutterBottom
            component="div"
            color={'black'}
          >
            {t('finance.mesComptes.addAccount')}
          </Typography>
        </DialogTitle>

        <DialogContent style={{ paddingTop: '5px' }}>
          <AddAccounts
            state={state}
            handleChange={handleChange}
            handleAutocomplete={handleAutocomplete}
            handleFileUpload={handleFileUpload}
          />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={addAccount}>
            {t('finance.common.confirm')}
          </Button>
          <Button
            onClick={() => {
              if (w_account) {
                localStorage.removeItem('w-account')
                navigate('/')
              }
              handleClose()
            }}
            autoFocus
          >
            {t('finance.common.cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
